import { DestroyRef, Directive, OnInit, Optional, Self } from '@angular/core';
import { AbstractControl, FormControlDirective, FormGroupDirective } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged } from 'rxjs';
import { ReviewDetailTabsService } from '../lib/review-detail-tabs.service';
import { CommonDataService } from '../services/common-data.service';

@Directive({
    selector: '[trackChanges]',
    standalone: true
})
export class TrackChangesDirective implements OnInit {

    private control: AbstractControl | null = null;

    constructor(
        @Optional() @Self() private readonly formGroupDirective: FormGroupDirective,
        @Optional() @Self() private readonly formControlDirective: FormControlDirective,
        private readonly reviewDetailTabsService: ReviewDetailTabsService,
        private readonly commonDataService: CommonDataService,
        private readonly destroyRef: DestroyRef
    ) { }

    ngOnInit() {
        this.control = this.resolveControl();
        if (!this.control) {
            console.error('TrackChangesDirective: No FormControl or FormGroup found.');
            return;
        }
        this.control.valueChanges.pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            const isNotReadOnly = !this.commonDataService.libraryReadOnlyMode;
            if (isNotReadOnly && this.control!.dirty) {
                this.reviewDetailTabsService.markAsUnsavedChanges();
            }
        });
    }

    private resolveControl(): AbstractControl | null {
        if (this.formControlDirective) {
            return this.formControlDirective.control;
        }
        if (this.formGroupDirective) {
            return this.formGroupDirective.control;
        }
        return null;
    }
}
